var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 5.33333V10.6667L10.6666 5.33333H5.33331ZM21.3333 5.33333L26.6666 10.6667V5.33333H21.3333ZM26.6666 26.6667V21.3333L21.3333 26.6667H26.6666ZM5.33331 26.6667H10.6666L5.33331 21.3333V26.6667ZM25.3333 16C25.3333 10.84 21.16 6.66666 16 6.66666C10.84 6.66666 6.66665 10.84 6.66665 16C6.66665 21.16 10.84 25.3333 16 25.3333C21.16 25.3333 25.3333 21.16 25.3333 16ZM16 22.6667C12.32 22.6667 9.33331 19.68 9.33331 16C9.33331 12.32 12.32 9.33333 16 9.33333C19.68 9.33333 22.6666 12.32 22.6666 16C22.6666 19.68 19.68 22.6667 16 22.6667Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReCenter);
export default __webpack_public_path__ + "static/media/re-center.cd7796c9.svg";
export { ForwardRef as ReactComponent };